export default "__VITE_ASSET__BJ8$7vYG__"